import React, { useState } from "react";
import NewTransactionManager from "../DataArchive/TransactionManager/NewTransactionManager";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobDocuments } from "src/redux/reducers/JobDocument";
import queryString from "query-string";
import { useLocation, useHistory } from "react-router-dom";
import { fetchTotals } from "src/redux/reducers/Reconciler";
import { Tab, Tabs, Badge, Button } from "react-bootstrap";
import { FraudData } from "../FraudViewer";
import { AnalyzeTabGated, CategorizeTabGated } from "../Analyze";
import { useQueryStateSync } from "../../../custom-hooks/useQueryStateSync";
import { fetchMfs } from "src/redux/reducers/TransactionManager";
import { clearJob } from "src/redux/reducers/TemplateField";
import { clearJobData } from "src/redux/reducers/JobData";
import { ReduxState } from "src/redux";
import { useRecentDocument } from "src/hooks/useRecentNavigation";

export const Transactions = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const { queryParams, querySetters } = useQueryStateSync({
    mode: "reconcile",
    analyzeMode: "categorize",
  });

  const mode = queryParams.mode;
  const [activeTab, setActiveTab] = useState(() => {
    switch (mode) {
      case "categorize":
        return "2";
      case "analyze":
        return "3";
      case "fraud":
        return "4";
      default:
        return "1";
    }
  });

  const { selectedL1, selectedL2 } = useSelector(
    (state: ReduxState) => state.TagLevel
  );
  const { job } = useSelector((state: ReduxState) => state.JobData);

  // Track this page view as a recent document
  useRecentDocument(
    selectedL1 && selectedL2
      ? {
          docType: "bank-statements",
          label: `Bank Transactions - ${selectedL2}`,
          icon: "university",
          l1: selectedL1,
          l2: selectedL2,
        }
      : null
  );

  // React.useEffect(() => {
  //   dispatch(clearJobData());
  // }, []);

  React.useEffect(() => {
    // const { l1, l2 } = queryString.parse(location.search);
    // console.log("1");
    dispatch(
      fetchJobDocuments({
        fieldName: "bankMode",
      })
    );
    dispatch(fetchMfs());
    dispatch(fetchTotals());
  }, [job?.id, selectedL1, selectedL2]);

  return (
    <div className="p-4">
      {/* <div style={{ float: "right", marginBottom: "8px" }}>
        <Button
          variant="link"
          className="mr-2 d-inline-flex flex-column align-items-center"
          onClick={() => {
            history.push(`${location.pathname}${location.search}&mode=analyze`);
          }}
        >
          <span>Advanced Analysis</span>
          <small className="text-muted">
            Flow of funds & cashflow analysis
          </small>
        </Button>
        <Button
          variant="link"
          className="d-inline-flex flex-column align-items-center"
          onClick={() => {
            history.push(`${location.pathname}${location.search}&mode=fraud`);
          }}
        >
          <span>Fraud Detection</span>
          <small className="text-muted">Identify suspicious patterns</small>
        </Button>
      </div> */}

      <Tabs
        activeKey={activeTab}
        id="transaction-tabs"
        onSelect={(activeTab) => {
          setActiveTab(activeTab || "1");
          if (activeTab === "2") {
            querySetters.set_mode("categorize");
            querySetters.set_analyzeMode("categorize");
          } else if (activeTab === "1") {
            querySetters.set_mode("reconcile");
            querySetters.set_analyzeMode("reconcile");
          } else if (activeTab === "3") {
            querySetters.set_mode("analyze");
            querySetters.set_analyzeMode("flow");
          } else if (activeTab === "4") {
            querySetters.set_mode("fraud");
            querySetters.set_analyzeMode("fraud");
          }
        }}
      >
        <Tab eventKey="1" title="Reconcile">
          {activeTab === "1" && (
            <NewTransactionManager hideJobButtons={false} />
          )}
        </Tab>
        <Tab
          eventKey="2"
          title={
            <>
              <span>Categorize</span>
            </>
          }
        >
          {activeTab === "2" && <CategorizeTabGated />}
        </Tab>
        <Tab
          eventKey="3"
          title={
            <div className="d-flex align-items-center">
              <span>Advanced Analysis</span>
              <Badge
                variant="secondary"
                className="ml-2"
                style={{ fontSize: "0.7em" }}
              >
                Business
              </Badge>
            </div>
          }
        >
          {activeTab === "3" && <AnalyzeTabGated />}
        </Tab>
        <Tab
          eventKey="4"
          title={
            <div className="d-flex align-items-center">
              <span>Fraud Detection</span>
              <Badge
                variant="secondary"
                className="ml-2"
                style={{ fontSize: "0.7em" }}
              >
                Business
              </Badge>
            </div>
          }
        >
          {activeTab === "4" && <FraudData />}
        </Tab>
      </Tabs>
    </div>
  );
};
